<template>
  <div ref="aaa" class="main">
    <div
      class="body"
    >
      <!-- <div class="main-container-wrapper close" ref="close">
        <el-button type="info" icon="el-icon-close" @click="closeC"></el-button>
      </div> -->
      <main-header :info="childLength"></main-header>
      <main-menu-bar :stat="statusM"></main-menu-bar>
      <div class="main-content">
        <div class="main-container-wrapper" style="background-color: #f3f3f3">
          <div class="main-content-inner">
            <router-view></router-view>
          </div>
          <content-tool-bar />
          <!-- <div class="waveWindow" ref="waveWindow">
            <div
              class="info"
              style="
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
              "
            >
              <span>{{ waveName }}</span>
              <a style="width: auto; height: auto" :href="waveHref">{{
                waveHref
              }}</a>
            </div>
            <a :href="waveHref">
              <img :src="waveImage" alt="" />
              <span></span>
            </a>
            <el-button
              style="position: absolute; top: 0; right: 0"
              type="warning"
              icon="el-icon-close"
              @click="waveClose"
              >关闭</el-button
            >
          </div> -->
          <!-- <div class="leftFixd" ref="leftFixd">
            <a :href="leftHref">
              <img :src="leftImage" alt="" />
              <span></span>
            </a>
            <el-button type="warning" icon="el-icon-close" @click="leftClose"
              >关闭</el-button
            >
          </div>
          <div class="rightFixd" ref="rightFixd">
            <a :href="rightHref">
              <img :src="rightImage" alt="" />
              <span></span>
            </a>
            <el-button type="warning" icon="el-icon-close" @click="rightClose"
              >关闭</el-button
            >
          </div> -->
        </div>
      </div>
      <main-footer />
      <!-- <wave></wave> -->
    </div>
    <Sidebar @back-top="runs" />
  </div>
</template>

<script>
import MainHeader from "../../components/MainHeader";
import MainFooter from "../../components/MainFooter";
import MainMenuBar from "../../components/MainMenuBar";
import ContentToolBar from "../../components/ContentToolBar";
import Sidebar from "../../components/Sidebar/index";
// import wave from "../../components/wave";
// const cubic = value => Math.pow(value, 3);
// const easeInOutCubic = value => value < 0.5
//     ? cubic(value * 2) / 2
//     : 1 - cubic((1 - value) * 2) / 2;
import { URL_LAWS_FIND } from "../../utils/api";
import util from "../../utils/util";
import { frontHeater } from "../../utils/md5encryption";

export default {
  name: "Main",
  components: { ContentToolBar, MainMenuBar, MainFooter, MainHeader, Sidebar },
  data() {
    return {
      el: null,
      // 顶部活动图地址
      coverImgUrl: "",
      // 传给头部让他top
      childLength: "0",
      // 传给控制头部的下边的宽度
      statusM: true,
      // 左侧跳转链接
      leftHref: "#",
      // 左侧图片
      leftImage: "",
      // 右侧跳转链接
      rightHref: "#",
      // 右侧图片
      rightImage: "",
    };
  },
  mounted() {
    this.el = document.documentElement;
    // this.getTopList();
    // this.getLeftList();
    // this.getRightList();
    // this.getWaveWindow();
  },

  methods: {
    runs() {
      this.$refs.aaa.scrollIntoView({ behavior: "smooth" });
      // console.log(this.$refs.aaa.scrollIntoView());
      // this.$refs.aaa.scrollTop = 0
    },
    // 右侧广告
    waveClose() {
      this.$refs.waveWindow.style.display = "none";
    },
    // 顶部数据
    getTopList() {
      let Url = util.getAjaxUrl("axiosThree");
      let UrlTw = util.getAjaxUrl("axiosOne");
      let params = {
        position: "bac",
        isOpen: 1,
        pageNumber: 1,
        pageSize: 1,
        isList: "0",
      };
      this.$http
        .post(Url + "/api/DataCmsAdvertisingManage/find", params)
        .then((res) => {
          if (res.status === 200) {
            if (res.data.data.length === 1) {
              this.coverImgUrl =
                UrlTw + "/api/getPicture?path=" + res.data.data[0].picUrl;
            } else {
              this.closeC();
            }
          } else {
            this.closeC();
          }
        });
    },
    // 顶部活动图片关闭
    closeC() {
      this.$refs.close.style.display = "none";
      this.coverImgUrl = null;
      this.childLength = "0px";
      this.statusM = false;
    },
    // 左侧数据
    getLeftList() {
      let Url = util.getAjaxUrl("axiosThree");
      let UrlTw = util.getAjaxUrl("axiosOne");
      let params = {
        position: "left",
        isOpen: 1,
        pageNumber: 1,
        pageSize: 1,
        isList: "0",
      };
      this.$http
        .post(Url + "/api/DataCmsAdvertisingManage/find", params)
        .then((res) => {
          if (res.status === 200) {
            if (res.data.data.length === 1) {
              if (res.data.data[0].picUrl) {
                this.leftImage =
                  UrlTw + "/api/getPicture?path=" + res.data.data[0].picUrl;
                this.leftHref = res.data.data[0].connectUrl;
              } else {
                this.leftClose();
              }
            } else {
              this.leftClose();
            }
          } else {
            this.leftClose();
          }
        });
    },
    // 左侧广告
    leftClose() {
      this.$refs.leftFixd.style.display = "none";
    },
    // 右侧数据
    getRightList() {
      let Url = util.getAjaxUrl("axiosThree");
      let UrlTw = util.getAjaxUrl("axiosOne");
      let params = {
        position: "right",
        isOpen: 1,
        pageNumber: 1,
        pageSize: 1,
        isList: "0",
      };
      this.$http
        .post(Url + "/api/DataCmsAdvertisingManage/find", params)
        .then((res) => {
          if (res.status === 200) {
            if (res.data.data.length === 1) {
              this.rightImage =
                UrlTw + "/api/getPicture?path=" + res.data.data[0].picUrl;
              this.rightHref = res.data.data[0].connectUrl;
            } else {
              this.rightClose();
            }
          } else {
            this.rightClose();
          }
        });
    },
    // 右侧广告
    rightClose() {
      this.$refs.rightFixd.style.display = "none";
    },
  },
};
</script>

<style scoped lang="less">
@import "../../styles/theme";
.body {
  overflow: hidden;
  background-size: 100% 100vh;
  background-repeat: no-repeat;
  /*background: #f3f3f3;*/
  background: #fff;
}
/deep/.el-button--info {
  transform: scale(0.5);
  border-color: black;
  color: white;
  float: right;
  margin-top: 30px;
  margin-right: 30px;
  background: rgba(0, 0, 0, 0.4);
}
/deep/.el-button--info:hover {
  transform: scale(0.8);
  background: rgba(0, 0, 0, 1);
}
/deep/.el-button--warning {
  transform: scale(0.5);
  border-color: black;
  color: white;
  float: right;
  margin-right: -15px;
  margin-top: -6px;
  z-index: 300;
  display: none;
  background: rgba(0, 0, 0, 0.7);
}
.leftFixd:hover /deep/.el-button--warning {
  display: block;
}
.rightFixd:hover /deep/.el-button--warning {
  display: block;
}
.waveWindow:hover /deep/.el-button--warning {
  display: block;
}
/deep/.el-button--warning:hover {
  // transform: scale(0.8);
  background: rgba(0, 0, 0, 1);
}
.main-content {
  // background: @main-content-color;
  position: relative;
  .main-content-inner {
    /*width: 1200px;*/
    width: 1150px;
    margin: 0 auto;
    background: @white;
    min-height: calc(
      100vh - @height-header - @height-footer - @height-menu-bar -
        @height-tool-bar
    );
  }

  .leftFixd {
    position: absolute;
    left: 0.5%;
    z-index: 201;
    top: 0;
    // bottom: 0px;
    width: 200px;
    height: 250px;
    // background: #7c2121;
    border-color: black;
    // animation: leftBot 4s ease;
    a {
      width: 100%;
      height: 100%;
      img {
        position: absolute;
        top: 25px;
        width: 100%;
        height: 100%;
      }
    }
  }

  .waveWindow {
    position: absolute;
    left: 0.5%;
    z-index: 201;
    top: 0;
    width: 200px;
    height: 250px;
    border-color: black;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    a {
      width: 100%;
      height: 100%;
      img {
        position: absolute;
        top: 30px;
        width: 100%;
        height: 100%;
      }
    }
  }

  @keyframes leftBot {
    0% {
      bottom: -300px;
    }

    100% {
      bottom: 0px;
    }
  }
  @keyframes rightBot {
    0% {
      bottom: -300px;
    }

    100% {
      bottom: 0px;
    }
  }
  .rightFixd {
    position: absolute;
    right: 0.5%;
    top: 0;
    // bottom: 0px;
    width: 200px;
    z-index: 201;
    height: 250px;
    // background: #7c2121;
    border-color: black;
    // animation: leftBot 4s ease;
    a {
      width: 100%;
      height: 100%;
      img {
        position: absolute;
        top: 25px;
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
